export default __webpack_public_path__ + "static/media/litecoin.53875176.svg";